module.exports = __webpack_public_path__ + "assets/img/btn-view-1bd30e07.png";